'use client';

import * as React from 'react';

/**
 * @useClient
 */
export const GamePad = React.memo(function GamePad() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h50v50H0z" />
        <path fill="#837F91" fillRule="nonzero" d="M36.244 7c-3.826 0-5.116 2.764-11.246 2.764C18.98 9.764 17.506 7 13.752 7 3.334 7 1 27.75 1 35.696 1 39.986 2.634 43 5.938 43c6.916 0 5.852-10 13.83-10h10.46c7.978 0 6.914 10 13.83 10C47.362 43 49 39.988 49 35.698 49 27.752 46.662 7 36.244 7zM15 27a6 6 0 1 1 0-12 6 6 0 0 1 0 12zm20-12a2 2 0 1 1 .001 3.999A2 2 0 0 1 35 15zm-4 8a2 2 0 1 1-.001-3.999A2 2 0 0 1 31 23zm4 4a2 2 0 1 1-.001-3.999A2 2 0 0 1 35 27zm4-4a2 2 0 1 1-.001-3.999A2 2 0 0 1 39 23zm-20.5-2c0 1.93-1.57 3.5-3.5 3.5s-3.5-1.57-3.5-3.5 1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5z" />
      </g>
    </svg>;
});